import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { SEARCH_LIMIT_MESSAGE, SEARCH_MAX_LENGTH } from '../shared/directive/search-limit.directive';

const SEARCH_PARAM_KEYS = new Set(['search', 'searchterm', 'name', 'displayname', 'query', 'q']);

/**
 * A search that is already over the limit must not reach the API.
 * Pages that still send it get the same sentence as the field, not a generic fetch error.
 * Code 2011 is the shape ServerErrorUtils already turns into that sentence.
 */
@Injectable()
export class SearchLimitInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.method !== 'GET' || !this.hasOversizedSearch(request)) {
      return next.handle(request);
    }
    return throwError(() => new HttpErrorResponse({
      status: 400,
      error: { error: { code: '2011', messages: [SEARCH_LIMIT_MESSAGE] } },
    }));
  }

  private hasOversizedSearch(request: HttpRequest<unknown>): boolean {
    return request.params.keys().some(key => {
      if (!SEARCH_PARAM_KEYS.has(key.toLowerCase())) {
        return false;
      }
      return (request.params.get(key) || '').length > SEARCH_MAX_LENGTH;
    });
  }
}
